import { writable } from "svelte/store";
import { getDefaultLanguage } from "../../shared/util/i18n";
import { storage } from "../util/localStorage";
export const language = writable();
export const defaults = {
    language: getDefaultLanguage()
};
export function init() {
    language.set(storage.getOrElse("language", defaults.language));
    language.subscribe(newValue => storage.set("language", newValue));
}
